goog.provide('el8.appchart.dialog.ordermed.selectThread');

goog.require('el8.uiwidget.Component');
goog.require('el8.uiwidget.ComponentDialog');
goog.require('el8.template.appchart.dialog.ordermed.selectThread');
goog.require('el8.ptdata.medOrderThreads');


el8.appchart.dialog.ordermed.selectThread = (function() {

    var selectCallbackFn = null;

    var that = new el8.uiwidget.ComponentDialog({
        title: 'New Rx is Related To:',
        modal: true,
        height: 500,
        width: 500,
        contentFn: el8.template.appchart.dialog.ordermed.selectThread.content
    });

    var component = new el8.uiwidget.Component({
        initFn: function() {
            that.getContentElt().on('click', '.select-thread-trigger',  function(e) {
                var threadId = $(this).attr('data-id')*1;
                if (selectCallbackFn) { selectCallbackFn(threadId); }
                // Once selection made, dialog closes
                that.hide();
            });
        },
        dataRenderers: [
            {
                entitySet: el8.ptdata.medOrderThreads,
                renderFn: function() {
                    if (!that.isOpen()) { return; }
                    $('#select-thread-container', that.getContentElt()).html(
                        el8.template.appchart.dialog.ordermed.selectThread.allLists(
                            el8.ptdata.medOrderThreads.getSortedSoyMaps()
                        )
                    );
                },
                events: [{eventName: 'all'}]
            }
        ]
    });
    that.setComponent(component);

    var super_show = that.show;
    that.show = function(doLoad, _selectCallbackFn) {
        selectCallbackFn = _selectCallbackFn;
        super_show.call(that, doLoad);
    };

    return that;

})();
